import { fromJS } from 'immutable';

import { ApiBacklogClient, UserToken } from '../../../helper/HelperAuth'
import doFetch from '../../../infra/helper/fetchHelper'

export default (clientid) => async (dispatch, getState) => {
    
    const Authorization = UserToken;
    
    const url = ApiBacklogClient + 'detail-client?client='+clientid;
    
    const argument = {  
        method: 'GET',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
            // 'Authorization': "token123",
        }
    }; 

    const response = await doFetch(url,argument);
    var data = fromJS({});
    if(response.ok){
        data = fromJS({});

        try{
            var resJson = await response.json()
            if(resJson !== '' || resJson !== null){
                data = fromJS(resJson);
                data = data.get('data');
            }else{
                data = fromJS({});
            }    
        }catch(ex){
            data = fromJS({});
        }
    }

    return data;
};